export default __webpack_public_path__ + "static/media/arm-right-front.50441f9b.png";